import React from "react";

function Progress({ totalSteps, step, vertical = false }) {
  const progress =
    totalSteps > 1 ? ((step - 1) / (totalSteps - 1)) * 100 : 0;

  // Vertical Progress
  if (vertical) {
    return (
      <div
        style={{
          width: "4px",
          height: "80%",
          background: "#e5e7eb",
          position: "absolute",
          left: "32px",
          top: "24px"
        }}
      >
        <div
          style={{
            width: "4px",
            height: `${progress}%`,
            background: "#0061bb",
            transition: "all 0.4s ease-in"
          }}
        ></div>
      </div>
    );
  }

  return (
    <div
      className="progress"
      style={{
        height: "4px",
        background: "#ddd",
        width: "100%",
        transition: "all 0.4s ease-in",
      }}
    >
      <div
        style={{
          height: "4px",
          background: "#0061bb",
          width: `${progress}%`,
          transition: "all 0.4s ease-in",
        }}
      ></div>
    </div>
  );
}

export default Progress;